import React, { useContext } from "react";
import { SearchContext } from "../context/context.jsx";
import Spinner from "../components/Spinner/Spinner.jsx";
import Sidebar from "./Sidebar/Sidebar.jsx";
import Header from "./Header/Header.jsx";
import Cards from "./Cards/Cards.jsx";
import Map from "./Map/Map.jsx";
import SearchByMove from "./SearchByMove/SearchByMove.jsx";
import { SET_SEARCH_BY_MOVE, SET_MAP_DATA } from "../actions/actionTypes.js";

export default () => {
  const [context, dispatch] = useContext(SearchContext);
  const { view, data, dataMeta, loading, requestCounter, searchByMoveActive, searchByMoveLoading, notPaginatedData } =
    context;

  function handleSearchByMoveClick(value) {
    dispatch({
      type: SET_SEARCH_BY_MOVE,
      payload: {
        value,
      },
    });
  }

  function onMapPositionChange(radius, mapCenter) {
    let resolvedMapCenter = null

    if (window.lrgDisableMapMovementCallback === true) {
      return
    }

    if (mapCenter && mapCenter.lat && mapCenter.lng) {
      resolvedMapCenter = `${mapCenter.lat()},${mapCenter.lng()}`
    }

    dispatch({
      type: SET_MAP_DATA,
      payload: {
        radius,
        mapCenter: resolvedMapCenter
      },
    });
  }


  return (
    <div className="c-search container">
      <div className="c-search__container">
        <Sidebar view={view} />

        <div className="c-search__main">
          <div class="c-search__mainContainer container">
            <Header dispatch={dispatch} dataMeta={dataMeta} view={view} searchByMoveActive={searchByMoveActive} />
          </div>
          {view === "map" ? (
            <div className="c-search__mapWrapper">
              <Map
                restaurants={data}
                notPaginatedRestaurants={notPaginatedData}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDfEbj2R0tluLwQuq_t-mTFzHGub8tblYk&libraries=places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div className="c-searchMap__container" />}
                mapElement={<div style={{ height: `100%` }} />}
                onMapPositionChange={onMapPositionChange}
                searchByMoveActive={searchByMoveActive}
              />
              <SearchByMove
                onClick={handleSearchByMoveClick}
                active={searchByMoveActive}
                loading={searchByMoveLoading}
              />
            </div>
          ) : (
            <Cards
              restaurants={data}
              view={view}
              requestCounter={requestCounter}
            />
          )}
        </div>
        <Spinner loading={loading} />
      </div>
    </div>
  );
};
